export const AutoInsuranceRequireModel = [
  {
    formName: 'formAutoInsurancePlan',
    fieldRequired: [
      'exploitingType',
      'businessProgramCode',
      'exploitingCode',
      'curencyMoney',
      'curencyFee',
      'exchangeRate',
    ],
  },
  {
    formName: 'formAutoOfferFee',
    fieldRequired: [
      'packageCode',
      'name',
      'manufacturingYear',
      'startDate',
      'expireDate',
      'seat',
      'payload',
      'carCompany',
      'carBrand',
      'driverNumber',
      'vehicleGroupsCode',
      'purposeOfUseType',
      'price',
      'amountCar',
    ],
  },
  {
    formName: 'formAutoListUser',
    fieldRequired: [
      'certType',
      'code',
      'objectInsuredType',
      'vehicleGroupsCode',
      'vehicleOwner',
      'address',
      'carCompany',
      'carBrand',
      'manufacturingYear',
      'seat',
      'payload',
      'driverNumber',
      'purposeOfUseType',
      'price',
      'startDate',
      'expireDate',
    ],
  },
  {
    formName: 'formAutoContract',
    fieldRequired: [
      'contractType',
      'purchaseDate',
      'startDate',
      'endDate',
      'taxType',
    ],
  },
]
